// 交易看板图表组件
export default {
  // 标题
  trendTitle: "转入/转出趋势",

  // 数量统计
  transferInAmount: "转入数量：",
  transferOutAmount: "转出数量：",
  tenThousand: "万",

  // 时间段选项
  currentWeek: "本周",
  currentMonth: "本月",
  halfYear: "半年",
  currentYear: "全年",

  // 日期选择器
  startDate: "开始日期",
  endDate: "结束日期",

  // 图表配置
  unit: "单位:(万)",
  transferInSeries: "转入数量",
  transferOutSeries: "转出数量",
};
